import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/status/update/user.status.update.mutation.gql"
import type {
  UserStatusUpdateMutation,
  UserStatusUpdateMutationVariables,
} from "@/v2-backoffice-client/user/status/update/__types__/user.status.update.mutation"

type Options = MutationHookOptions<
  UserStatusUpdateMutation,
  UserStatusUpdateMutationVariables
>

export function useUserStatusUpdateMutation(options?: Options) {
  return useMutation<
    UserStatusUpdateMutation,
    UserStatusUpdateMutationVariables
  >(mutation, options)
}
